import { render, staticRenderFns } from "./tagEditor.vue?vue&type=template&id=349cc842&scoped=true&"
import script from "./tagEditor.vue?vue&type=script&lang=js&"
export * from "./tagEditor.vue?vue&type=script&lang=js&"
import style0 from "./tagEditor.vue?vue&type=style&index=0&id=349cc842&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349cc842",
  null
  
)

export default component.exports